import styled, { css } from 'styled-components';
import { CardBodyProps } from './CardBody';

export const Element = styled.div<CardBodyProps>`
  ${({ theme, ...props }) => {
    return css`
      padding: ${theme.spacing.base};
    `;
  }};
`;
